import { makeWidgetProps, asWidgetProps } from 'Src/types/widget-helpers';
import React, { ComponentProps } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { isEmpty } from 'lodash';
import type { AwardProps } from 'Components/widgets/tripadvisor-awards/TripAdvisorAwards';
import { TripAdvisorAwards } from 'Components/widgets/tripadvisor-awards/TripAdvisorAwards';
import type { TripAdvisorRatingsProps } from 'Components/widgets/tripadvisor-ratings/TripAdvisorRatings';
import { TripAdvisorRatings } from 'Components/widgets/tripadvisor-ratings/TripAdvisorRatings';
import type { ReviewProps } from 'Components/widgets/tripadvisor-reviews/TripAdvisorReviews';
import { TripAdvisorReviews } from 'Components/widgets/tripadvisor-reviews/TripAdvisorReviews';
type Props = {
  className?: string;
  awards?: Array<AwardProps>;
  ratings?: TripAdvisorRatingsProps;
  reviews?: Array<ReviewProps>;
};
export const TripAdvisorLarge = ({
  awards = [],
  className,
  ratings = makeWidgetProps<TripAdvisorRatingsProps>({}),
  reviews,
}: Props) => {
  if (isEmpty(awards) && isEmpty(ratings.subratings) && isEmpty(reviews)) {
    return null;
  }

  const classes =
    'border-1 border-lightGrey flex items-center justify-center p-15 rounded-12 w-1/3';
  return (
    <section className={classnames('flex justify-center gap-20', className)}>
      {!isEmpty(ratings.subratings) && (
        <div className={classnames(classes, 'w-380')}>
          <TripAdvisorRatings
            {...asWidgetProps<ComponentProps<typeof TripAdvisorRatings>>({
              className: 'w-full max-w-full',
              ...ratings,
              subratings: ratings.subratings,
            })}
          />
        </div>
      )}
      {!isEmpty(reviews) && (
        <div className={classnames(classes, 'flex-1')}>
          <TripAdvisorReviews
            {...asWidgetProps<ComponentProps<typeof TripAdvisorReviews>>({
              className: 'w-full max-w-full',
              maxLengthOfReview: 150,
              reviews: reviews,
            })}
          />
        </div>
      )}
      {!isEmpty(awards) && (
        <div className={classnames(classes, 'w-280')}>
          <TripAdvisorAwards
            {...asWidgetProps<ComponentProps<typeof TripAdvisorAwards>>({
              className: 'w-full max-w-full',
              awards: awards,
            })}
          />
        </div>
      )}
    </section>
  );
};
